<template>
  <v-container fluid>
    <v-row>
      <v-col style="z-index:10;" class="py-0 my-0" cols=12>
        <v-tabs show-arrows>
          
          <v-tab v-if="$env.VUE_APP_WHITE_MARK_ID != 'fp'" to="/maps/radar">{{$t('radar_sat')}}</v-tab>
          <v-tab v-if="$env.VUE_APP_WHITE_MARK_ID != 'fp'" to="/maps/weathermap">{{$t('technical_map')}}</v-tab>
          <v-tab  to="/maps/stormwatch">Stormwatch</v-tab>
          <v-tab v-if="$env.VUE_APP_WHITE_MARK_ID != 'fp'" to="/maps/hail">Grêle</v-tab>
        </v-tabs>
      </v-col>
      <v-col>
        <router-view/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

}
</script>

<style>
</style>